import { createFileRoute } from '@tanstack/react-router';

import { InboxMobilePage } from '@/pages/inbox/inbox-mobile-page';
import { InboxPage } from '@/pages/inbox/inbox-page';
import { useMobile } from '@/shared/lib/use-mobile';

function InboxRoute() {
  const isMobile = useMobile();
  return isMobile ? <InboxMobilePage /> : <InboxPage />;
}

export const Route = createFileRoute('/inbox')({ component: InboxRoute });
